// extracted by mini-css-extract-plugin
export default {"modal":"ShRDZtSr","closeButton":"wXzkuA7j","closeIcon":"ghFJcLeW","overlay":"L573BVif"};